export default __webpack_public_path__ + "static/media/markdown-html-supported-blog.02d53e4c.md";